// extracted by mini-css-extract-plugin
export default {"container":"dZCcR0bOAX3da7NGgqUeH"};